<h6 class="prd-h6"> Agents </h6>
<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="card bg-light">
    <div class="card-body" *ngIf = 'displayState.workingDiv'>    
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
      </div>
</div>
<!--  Entry Div -->
<div class="row" *ngIf="displayState.editAgencyDiv" style="margin-top: 30px;">
    <div class="card bg-light col-md-8 offset-2">
        <div class="card-body">
            <!-- Agency Name -->
            <div class="form-row">
                <label for="inputAgencyName" class="col-sm-2 col-form-label prd-label">Agency</label>
                <div class="col-sm-6">
                    <input id="inputAgencyName" type="text" class="form-control form-control input-sm  prd-required" maxlength="50"
                            placeholder="Agency Name" [(ngModel)]="myAgency.name">
                </div>
            </div> <!-- end row -->
            <br />
            <div class="form-row">
                <label for="inputStrAddr" class="col-sm-2 col-form-label prd-label">Address</label>
                <div class="col-sm-6">
                    <input id="inputStrAddr" type="text" class="form-control input-sm" maxlength="100"
                            placeholder="Street Address" [(ngModel)]="myAgency.strAddr">
                </div>
                <label for="inputAddrUnit" class="col-sm-2 col-form-label prd-label">Unit</label>
                <div class="col-sm-2">
                    <input id="inputAddrUnit" type="text" class="form-control input-sm" maxlength="25"
                            placeholder="Unit #" [(ngModel)]="myAgency.addrUnit">
                </div>

            </div>
            <br />
            <div class="form-row">
                <label for="inputCity" class="col-sm-2 col-form-label prd-label">City</label>
                <div class="col-sm-3">
                    <input id="inputCity" type="text" class="form-control input-sm" maxlength="50" placeholder="City" [(ngModel)]="myAgency.city">
                </div>
                <label for="inputState" class="col-sm-2 col-form-label prd-label">State</label>
                <div class="col-sm-1">
                    <input id="inputState" type="text" class="form-control input-sm" maxlength="2" placeholder="State" [(ngModel)]="myAgency.state">
                </div>
                <label for="inputZip" class="col-sm-2 col-form-label prd-label">Zip</label>
                <div class="col-sm-2">
                    <input id="inputZip" type="text" class="form-control input-sm" maxlength="10" placeholder="Zip Code" [(ngModel)]="myAgency.zip">
                </div>
            </div>
            <br />
            <div class="form-row">
                <label for="inputPhone" class="col-sm-2 col-form-label prd-label">Phone</label>
                <div class="col-sm-3">
                    <input id="inputPhone" type="tel" class="form-control prd-required input-sm" maxlength="18" placeholder="Phone" [(ngModel)]="myAgency.phone">
                </div>
                <label for="inputAltPhone" class="col-sm-2 col-form-label prd-label">Alt Phone</label>
                <div class="col-sm-3">
                    <input id="inputAltPhone" type="text" class="form-control input-sm" maxlength="18" placeholder="Alternate Phone" [(ngModel)]="myAgency.altPhone">
                </div>
            </div>
            <br />
            <div class="form-row">
                <label for="inputFax" class="col-sm-2 col-form-label prd-label">Fax</label>
                <div class="col-sm-3">
                    <input id="inputFax" type="text" class="form-control input-sm" maxlength="18" placeholder="Fax Number" [(ngModel)]="myAgency.fax">
                </div>
                <label for="inputEmail" class="col-sm-2 col-form-label prd-label">Email</label>
                <div class="col-sm-5">
                    <input id="inputEmail" type="text" class="form-control input-sm" maxlength="50" placeholder="Email Address" [(ngModel)]="myAgency.email">
                </div>
            </div>
            <br />
            <!-- Error Message -->
            <div class="col-sm-offset-3 col-sm-9 text-danger" ng-show="displayState.errorMessage"><p>{{displayState.errorMessage}}</p>  </div>

            <!-- Buttons -->
            <div class="form-row">
                <div class="offset-3 col-sm-7">
                    <button class="btn btn-success offset-3" (click)="saveAgency(myAgency)" [disabled] = "agencyNeedRequiredData()">Save</button>
                    <button class="btn btn-warning offset-2" (click)="cancelEntry()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row" *ngIf="displayState.gridDiv">
    <div class="col-md-1">
        <button class="btn btn-sm btn-link" (click)="newAgency()">New Agency</button>
    </div>
    <div class="col-md-12">
        <p-table #tabAgency [columns]="cols" [value]="agencyList" [responsive]="true" [scrollable]="true" scrollHeight="470px"  >
            <ng-template pTemplate="caption">
                &nbsp;&nbsp;&nbsp;
                <strong> Agencies </strong>
                <div class="ui-table-globalfilter-container">
                    <input type="text" pInputText size="40" [(ngModel)]="filterOptions.filterText" placeholder="Find Agency - Global Filter" title="Enter text for which to search" (change)="tabAgency.filterGlobal($event.target.value, 'contains')" style="width:200px;">
                </div>
                    </ng-template>
            <ng-template pTemplate="header">
                <tr style="font-size:smaller">
                    <th style="width: 7%" >&nbsp;</th>
                    <th [pSortableColumn]="'name'" style="width: 20%">
                    Company Name
                    <p-sortIcon [field]="'name'"></p-sortIcon>
                </th>

                <th [pSortableColumn]="'strAddr'" style="width: 20%">
                    Street Address
                    <p-sortIcon [field]="'strAddr'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'city'" style="width: 10%">
                    City
                    <p-sortIcon [field]="'city'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'phone'" style="width: 10%">
                    Phone#
                    <p-sortIcon [field]="'phone'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'email'" style="width: 15%" >
                    Email
                    <p-sortIcon [field]="'email'"></p-sortIcon>
                </th>
                <th style="width: 7%" >&nbsp;</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-agency>
                <tr style="font-size: small;">
                    <td style="width: 7%">
                        <button class='btn btn-sm btn-link' (click)="selectAgency(agency)">Select</button>
                    </td>
                    <td style="width: 20%">{{agency.name}}</td>    
                    <td style="width: 20%">{{agency.strAddr}}</td>
                    <td style="width: 10%">{{agency.city}}</td>
                    <td style="width: 10%">{{agency.phone}}</td>
                    <td style="width: 15%">{{agency.email }}</td>
                    <td style="width: 7%">
                    <button class='btn btn-sm btn-link' (click)="deleteAgency(agency)" [disabled]="userType === 'Read-Only' || userType === 'Appraiser'">Delete</button>
                </td>
    
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

